document.addEventListener('DOMContentLoaded', () => {
  const fixedLivePreview = () => {
    // Matches the Vue-rendered markup in
    // sections/customall-personalized-product-template.liquid (Customall's
    // Embla-based carousel), a different widget from TeeInBlue's — hence a
    // separate script (see tee-sticky-gallery.js for that one) rather than
    // sharing selectors.
    const galleryWrapperSelector = '.product-media';
    const $gallery = document.querySelector(galleryWrapperSelector);

    if (!$gallery) return;

    const SCALE = 0.45;
    const PADDING_Y = 0;
    const SAFETY_SCROLLING_RANGE = 20;
    // Hide once the form's bottom edge is within this many px of the
    // viewport top, instead of waiting for it to fully leave the screen.
    const HIDE_NEAR_FORM_BOTTOM_PX = 20;

    const style = document.createElement('style');
    style.innerHTML = `
      /* #artwork-preview carries a leftover position:sticky from the desktop
         layout (dormant on mobile — its height already equals its parent's,
         leaving no room to actually stick). Chrome mishandles a
         position:fixed descendant nested inside a position:sticky ancestor
         during compositing — the fixed element measures correctly
         (getBoundingClientRect matches its intended box) but paints at its
         pre-fixed, full document-flow size instead. Neutralizing the sticky
         ancestor while our own fixed bar is active avoids that. */
      .customall-gallery--sticky #artwork-preview {
        position: static;
      }
      .customall-gallery--sticky ${galleryWrapperSelector} {
        z-index: 9999;
      }
      @-webkit-keyframes customall-sticky-slide-in-down {
        0% { -webkit-transform: translate3d(0, -100%, 0); transform: translate3d(0, -100%, 0); visibility: visible; }
        to { -webkit-transform: translateZ(0); transform: translateZ(0); }
      }
      @keyframes customall-sticky-slide-in-down {
        0% { -webkit-transform: translate3d(0, -100%, 0); transform: translate3d(0, -100%, 0); visibility: visible; }
        to { -webkit-transform: translateZ(0); transform: translateZ(0); }
      }
      @-webkit-keyframes customall-sticky-slide-out-up {
        0% { -webkit-transform: translateZ(0); transform: translateZ(0); }
        to { -webkit-transform: translate3d(0, -100%, 0); transform: translate3d(0, -100%, 0); visibility: hidden; }
      }
      @keyframes customall-sticky-slide-out-up {
        0% { -webkit-transform: translateZ(0); transform: translateZ(0); }
        to { -webkit-transform: translate3d(0, -100%, 0); transform: translate3d(0, -100%, 0); visibility: hidden; }
      }
      ${galleryWrapperSelector} .customall-product-media {
        /* Entry only triggers once the real gallery has already scrolled
           fully out of view (see the stageBottom < 0 check below), so the
           top of the screen is already blank the instant this starts — a
           slow slide-in reads as "white gap, then the image shows up after
           a delay" rather than a smooth transition. Snappier than the
           .55s this was ported from (tee-sticky-gallery.js) keeps that gap
           barely noticeable. */
        -webkit-animation-duration: .18s;
        animation-duration: .18s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
      }
      .customall-gallery--sticky ${galleryWrapperSelector} .customall-product-media {
        -webkit-animation-name: customall-sticky-slide-in-down;
        animation-name: customall-sticky-slide-in-down;
      }
      .customall-gallery--sticky--leaving ${galleryWrapperSelector} .customall-product-media {
        -webkit-animation-duration: .3s !important;
        animation-duration: .3s !important;
        -webkit-animation-name: customall-sticky-slide-out-up !important;
        animation-name: customall-sticky-slide-out-up !important;
      }
      .customall-gallery--sticky ${galleryWrapperSelector} .customall-product-media {
        display: flex;
        justify-content: center;
        /* Without this, flex's default align-items:stretch forces
           .product-images-wrapper to shrink its OWN layout height down to
           the container's fixed height, which then fights with the
           scale(SCALE) transform doing the actual shrinking. Let it keep
           its natural size instead. */
        align-items: flex-start;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 99;
        padding: ${PADDING_Y}px 0;
        background-color: #fff;
        height: var(--customall-sticky-gallery-height, auto) !important;
        box-sizing: border-box;
        /* Height stays fixed regardless of zoom — whatever part of the
           zoomed .product-images-wrapper no longer fits gets clipped here
           instead of bleeding out over whatever page content sits below the
           bar. */
        overflow: hidden;
        /* On the content box itself, not .product-images-wrapper — a
           child's box-shadow would get clipped by this same
           overflow:hidden, but an element's OWN shadow is exempt from its
           own overflow, so it still renders past the bottom edge into the
           page content below. */
        box-shadow: 0 8px 12px -6px rgba(0, 0, 0, 0.25);
        /* This box (position:fixed, animated transform) and
           .product-images-wrapper inside it (transform:scale, set below)
           each get promoted to their own GPU compositing layer — but not
           necessarily in the same paint, since one is a CSS animation
           starting and the other a static transform already computed. That
           gap is what shows as the white box appearing a frame or two
           before the scaled image inside it catches up. will-change here
           and on .product-images-wrapper below asks the browser to
           promote both layers together, ahead of time, so they paint in
           sync instead of visibly one after the other. */
        will-change: transform;
      }
      /* Thumbnails stay visible in the DOM and full size — Embla (the
         carousel library Customily's widget runs on, unlike TeeInBlue's own
         simpler slider) tracks its slides' real rendered size via
         ResizeObserver, and display:none-ing an Embla-managed element (or
         any of its slides) makes it measure 0 and permanently corrupts its
         internal snap-point math — the corruption survives past leaving
         sticky, breaking the normal in-page gallery too. Left alone, the
         thumbnail strip and off-screen slides are simply clipped out by
         .customall-product-media's own overflow:hidden below, same visual
         result without ever touching Embla's layout. updateStickyHeight()
         sizes the fixed bar to just the main carousel's viewport for this
         reason — see its comment. */
      .customall-gallery--sticky ${galleryWrapperSelector} .embla.main-carousel .embla__button {
        display: none !important;
      }
      /* Blocks the swipe/drag gesture from switching the active slide
         without touching any Embla-managed element's visibility — pointer-
         events has no effect on Embla's own resize tracking, unlike
         display:none above. The page still scrolls vertically through it.
         Our own drag-to-pan-when-zoomed listeners are on
         .product-images-wrapper, an ancestor of the viewport, so they keep
         receiving events fine. */
      .customall-gallery--sticky ${galleryWrapperSelector} .embla.main-carousel .embla__viewport {
        pointer-events: none !important;
        touch-action: pan-y !important;
      }
      .customall-gallery--sticky ${galleryWrapperSelector} .product-images-wrapper {
        background: #fff;
        /* Customily sizes this chain with percentages. Once its parent is
           fixed, those percentages otherwise lose their normal-flow basis
           and collapse the carousel to 0, leaving a correctly sized but
           blank sticky bar. Preserve the pre-sticky viewport height as the
           transform's source box. */
        height: var(--customall-sticky-gallery-source-height, auto) !important;
        /* Overridden via the CSS var while zooming, combining the base
           shrink-to-fit scale with the current zoom level in one transform —
           see applyZoom(). .customall-product-media itself can't be the
           zoom target: it's mid-animation (slide-in/out), and a CSS
           animation's filled end value for the transform property always
           wins over anything set inline via JS, so it would silently
           ignore any scale we set.
           translate3d is the outermost function in the composed transform,
           so it moves the element by real screen pixels regardless of the
           scale() nested inside it — dragging feels 1:1 with the finger at
           any zoom level, and needs no extra math to convert between
           coordinate spaces the way it would if some further-out ancestor
           were also scaled (none is, here). */
        transform: translate3d(var(--customall-gallery-pan-x, 0px), var(--customall-gallery-pan-y, 0px), 0) scale(var(--customall-gallery-total-scale, ${SCALE}));
        transform-origin: top center;
        width: var(--customall-sticky-gallery-source-width, auto);
        /* touch-action itself is set inline by JS (applyZoom) — it needs to
           flip between pan-y and none depending on zoom level, so the page
           keeps scrolling normally through the gallery until the user
           actually zooms in. */
        /* See the will-change comment on .customall-product-media above —
           keeps this layer promoted alongside the outer box's so both
           paint together instead of the image visibly lagging behind the
           box it sits in. */
        will-change: transform;
      }
      .customall-gallery--sticky .customall-sticky-close-button {
        display: block;
      }
      .customall-sticky-close-button {
        background-image: url('data:image/svg+xml;utf8,<svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 16px 16px;
        display: none;
        height: 16px;
        opacity: 0.5;
        position: fixed;
        right: 20px;
        top: 20px;
        width: 16px;
        /* .customall-product-media runs a CSS animation (slide-in/out) with
           animation-fill-mode: both — that alone promotes it to its own
           compositing layer in Chrome, which can paint above a plain
           position:fixed sibling even at a much lower z-index than this
           button's. A very high value forces this button's layer on top
           regardless. */
        z-index: 2147483000;
      }
      /* Shown only after the user explicitly closes the sticky bar via the
         X — scrolling past it naturally hides it with no button, same as
         before. Lets them bring it back without scrolling up and back down
         past the trigger point. */
      .customall-sticky-reopen-button {
        display: none;
        position: fixed;
        top: 100px;
        right: 20px;
        width: 48px;
        height: 48px;
        padding: 0;
        border: none;
        border-radius: 50%;
        background-color: #fff;
        background-image: url('data:image/svg+xml;utf8,<svg version="1.1" id="Layer_2_1_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><path d="M114.5,79.1C95,79.1,79.1,95,79.1,114.5v283c0,19.5,15.8,35.4,35.4,35.4h283c19.5,0,35.4-15.8,35.4-35.4v-283 c0-19.5-15.8-35.4-35.4-35.4H114.5z M114.5,409.3c-6.5,0-11.8-5.3-11.8-11.8V308l94.3-94.3l195.6,195.6H114.5z M409.3,392.7 L331.6,315l30.5-30.5l47.2,47.2V392.7z M409.3,114.5v183.8l-38.8-38.9c-4.6-4.6-12.1-4.7-16.7-0.1c0,0,0,0-0.1,0.1L315,298.3 L205.4,188.7c-4.6-4.6-12.1-4.7-16.7-0.1c0,0,0,0-0.1,0.1l-86,86.1V114.5c0-6.5,5.3-11.8,11.8-11.8h283 C404,102.7,409.3,108,409.3,114.5z"/><path d="M326.7,138.1c-26,0-47.2,21.1-47.2,47.2s21.1,47.2,47.2,47.2s47.2-21.1,47.2-47.2S352.8,138.1,326.7,138.1z M326.7,208.8 c-13,0-23.6-10.6-23.6-23.6s10.6-23.6,23.6-23.6s23.6,10.6,23.6,23.6S339.8,208.8,326.7,208.8z"/><path d="M23.7,35c0,0,0.1-4.9,3.3-7.9c3.5-3.4,8.1-3.5,8.1-3.5l89.6,0c0-19.2,0-23.6,0-23.6L34.9,0C15.6,0,0,15.6,0,34.9l0,89.8 l23.7,0V35z"/><path d="M484.9,26.9c3.4,3.5,3.5,8.1,3.5,8.1l0,89.6c19.2,0,23.6,0,23.6,0l0-89.8C512,15.6,496.4,0,477.1,0l-89.8,0l0,23.7H477 C477,23.7,482,23.8,484.9,26.9z"/><path d="M488.3,477c0,0-0.1,4.9-3.3,7.9c-3.5,3.4-8.1,3.5-8.1,3.5l-89.6,0c0,19.2,0,23.6,0,23.6l89.8,0c19.2,0,34.8-15.6,34.8-34.8 l0-89.8l-23.7,0V477z"/><path d="M27.1,485.1c-3.4-3.5-3.5-8.1-3.5-8.1l0-89.6c-19.2,0-23.6,0-23.6,0l0,89.8C0,496.4,15.6,512,34.9,512l89.8,0l0-23.7H35 C35,488.3,30,488.2,27.1,485.1z"/></g></svg>');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 22px 22px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
        z-index: 2147483000;
        cursor: pointer;
      }
      .customall-sticky-reopen-button.is-visible {
        display: flex;
      }
      /* Zoom controls for the sticky gallery — bottom-right corner, zoom in
         stacked above zoom out. Created once by JS and left in the DOM, but
         only ever shown while sticky. */
      .customall-zoom-controls {
        display: none;
        position: absolute;
        bottom: 10px;
        right: 10px;
        z-index: 10;
        flex-direction: column;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 6px;
        overflow: hidden;
        box-shadow: 0 1px 4px rgba(0, 0, 0, .15);
      }
      .customall-gallery--sticky .customall-zoom-controls {
        display: flex;
      }
      .customall-zoom-controls button {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: #fff;
        font-size: 22px;
        line-height: 1;
        color: #333;
        cursor: pointer;
        padding: 0;
      }
      .customall-zoom-controls button.customall-zoom-in {
        border-bottom: 1px solid #ddd;
      }
      .customall-zoom-controls button:disabled {
        color: #bbb;
        cursor: not-allowed;
        background: #f5f5f5;
      }
    `;
    document.head.appendChild(style);

    let hasCloseButton = false;
    let hasReopenButton = false;
    let reopenButtonEl = null;
    let isSticky = false;
    let isLeaving = false;
    // Set once the X is used, so scrolling back into the trigger range
    // doesn't just show the bar again on its own — only the reopen button
    // should bring it back at that point. Cleared once that button is used,
    // so scroll-driven show/hide resumes normally until closed manually
    // again.
    let manuallyClosed = false;
    let lastCheckScrollY = null;

    let originalWrapperHeight = 0;
    // Distance from $gallery's top to the stage's bottom, measured while
    // NOT sticky (both still in normal flow). Kept fresh every non-sticky
    // check so it reflects the current layout, then reused once sticky to
    // derive an "equivalent stage bottom" — see the exit check below.
    let stageOffsetFromGalleryTop = null;

    const initialGalleryRect = $gallery.getBoundingClientRect();
    const stickyCondHeight =
      (initialGalleryRect.height || 0) + PADDING_Y * 2;

    // transform: scale() doesn't shrink the layout box a flex parent sizes
    // against, so letting .customall-product-media auto-size around the
    // (unscaled-for-layout) .product-images-wrapper would leave extra blank
    // space below the visually-scaled content. Compute the exact height
    // instead: the main carousel viewport's own (unscaled) height times
    // SCALE, plus top/bottom padding. Fixed regardless of zoom —
    // .customall-product-media clips to this height, so the thumbnail strip
    // below it (still full size and un-hidden — see the CSS comment above)
    // and whatever the zoomed image no longer fits into both get clipped
    // out rather than bleeding over page content below the bar. Deliberately
    // measures just the main carousel's viewport, not the whole
    // .product-images-wrapper (which also includes the thumbnail strip) —
    // sizing the box to that combined height was what let thumbnails show
    // inside it in the first place.
    const updateStickyHeight = () => {
      const mainViewport = document.querySelector(
        `${galleryWrapperSelector} .embla.main-carousel .embla__viewport`
      );
      if (!mainViewport) return;
      // Clear any height constraint left from a previous computation before
      // measuring — .customall-product-media's `height: var(--customall-sticky-gallery-height)`
      // would otherwise still be in effect, so the viewport gets measured
      // while already boxed into the PREVIOUS (slightly off) value, making
      // each successive sticky show compute a smaller height than the last.
      const previousHeight = document.documentElement.style.getPropertyValue(
        '--customall-sticky-gallery-height'
      );
      document.documentElement.style.removeProperty('--customall-sticky-gallery-height');
      if (!mainViewport.offsetHeight) {
        // Selecting an option that adds a new required field (e.g. a custom
        // title) makes Customily swap the mockup for a same-slide loading
        // placeholder with no intrinsic size while it regenerates the
        // preview — the viewport genuinely measures 0 for that moment.
        // Collapsing the bar to match would make the whole sticky gallery
        // (X button included) vanish, and nothing would bring it back since
        // isSticky never actually left true. Keep the last known good
        // height instead, so the bar just sits there at its previous size
        // until real content is measurable again.
        if (previousHeight) {
          document.documentElement.style.setProperty(
            '--customall-sticky-gallery-height',
            previousHeight
          );
        }
        return;
      }
      const targetHeight = mainViewport.offsetHeight * SCALE + PADDING_Y * 2;
      document.documentElement.style.setProperty(
        '--customall-sticky-gallery-source-height',
        `${mainViewport.offsetHeight}px`
      );
      document.documentElement.style.setProperty(
        '--customall-sticky-gallery-source-width',
        `${mainViewport.offsetWidth}px`
      );
      document.documentElement.style.setProperty(
        '--customall-sticky-gallery-height',
        `${targetHeight}px`
      );
    };

    // The mockup image can still be loading at the exact moment sticky mode
    // is entered, rendering at some smaller placeholder size first —
    // measuring synchronously at entry then locks the box's height to that
    // too-small size, permanently clipping the bottom of the real image
    // once it finishes loading in (nothing re-measures afterward on its
    // own). Re-run the same height calculation whenever the main carousel
    // viewport's own size actually changes, for this or any other reason,
    // while sticky. Purely a passive observer (never writes to the
    // viewport), so it coexists fine with Embla's own internal size
    // tracking on the same element.
    let wrapperResizeObserverStarted = false;
    const watchWrapperSize = () => {
      if (wrapperResizeObserverStarted) return;
      const mainViewport = document.querySelector(
        `${galleryWrapperSelector} .embla.main-carousel .embla__viewport`
      );
      if (!mainViewport) return;
      wrapperResizeObserverStarted = true;
      new ResizeObserver(() => {
        if (isSticky) updateStickyHeight();
      }).observe(mainViewport);
    };

    // Embla's main-image carousel can end up pointed at the right slide
    // (the `embla__slide.current-slide` class) while its container's own
    // translateX lands somewhere else entirely, leaving the mockup image
    // dragged off to the side and just white space visible in the bar. Seen
    // in practice right after typing into the personalization form — the
    // widget's own re-render nudges Embla to re-snap to a slide, and Embla
    // measures that distance from the LIVE (0.45-scaled, since it's nested
    // inside .product-images-wrapper's transform) rendered pixels rather
    // than true layout pixels, then applies the result as a raw translateX
    // in the container's own (unscaled) coordinate space — so the move
    // lands at roughly SCALE of where it should, permanently: nothing about
    // it is mid-animation, it just stops there. offsetLeft is a layout
    // measurement, unaffected by the ancestor's transform, so re-deriving
    // the correct translateX from the current slide's offsetLeft and
    // reapplying it corrects the drift regardless of what triggered it.
    // Debounced so a real in-progress Embla scroll animation (which touches
    // this same style attribute on every frame) isn't fought mid-swipe —
    // only settles-but-wrong states get corrected.
    let emblaAlignFixTimer = null;
    const fixEmblaMockupAlignment = () => {
      const container = document.querySelector(
        `${galleryWrapperSelector} .product-images-wrapper .embla.main-carousel .embla__container`
      );
      if (!container) return;
      const current = container.querySelector('.embla__slide.current-slide');
      if (!current) return;
      const expected = -current.offsetLeft;
      const match = /translate3d\(\s*(-?[\d.]+)px/.exec(container.style.transform || '');
      const actual = match ? parseFloat(match[1]) : null;
      if (actual == null || Math.abs(actual - expected) < 2) return;
      container.style.transform = container.style.transform.replace(
        /translate3d\([^)]+\)/,
        `translate3d(${expected}px, 0px, 0px)`
      );
    };
    let emblaAlignObserverStarted = false;
    const watchEmblaAlignment = () => {
      if (emblaAlignObserverStarted) return;
      const container = document.querySelector(
        `${galleryWrapperSelector} .product-images-wrapper .embla.main-carousel .embla__container`
      );
      if (!container) return;
      emblaAlignObserverStarted = true;
      new MutationObserver(() => {
        if (!isSticky) return;
        clearTimeout(emblaAlignFixTimer);
        emblaAlignFixTimer = setTimeout(fixEmblaMockupAlignment, 200);
      }).observe(container, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true,
        childList: true,
      });
    };

    const getOverlayHeight = () => {
      const content = document.querySelector(
        `${galleryWrapperSelector} .customall-product-media`
      );
      if (content) {
        const rect = content.getBoundingClientRect();
        return rect.height;
      }
      const rect = $gallery.getBoundingClientRect();
      return rect.height || 0;
    };

    const applyOverlayLayout = () => {
      updateStickyHeight();
      const h = getOverlayHeight();
      if (!h) return;

      if (originalWrapperHeight) {
        $gallery.style.height = `${originalWrapperHeight}px`;
      }
      $gallery.style.display = 'block';
    };

    const clearOverlayLayout = () => {
      $gallery.style.removeProperty('height');
      $gallery.style.removeProperty('display');
    };

    const ensureReopenButton = () => {
      if (hasReopenButton) return;
      reopenButtonEl = document.createElement('button');
      reopenButtonEl.type = 'button';
      reopenButtonEl.className = 'customall-sticky-reopen-button';
      reopenButtonEl.setAttribute('aria-label', 'Show personalization preview');
      reopenButtonEl.addEventListener('click', e => {
        e.preventDefault();
        manuallyClosed = false;
        hideReopenButton();
        enterSticky();
      });
      document.body.appendChild(reopenButtonEl);
      hasReopenButton = true;
    };

    const showReopenButton = () => {
      ensureReopenButton();
      reopenButtonEl.classList.add('is-visible');
    };

    const hideReopenButton = () => {
      if (reopenButtonEl) reopenButtonEl.classList.remove('is-visible');
    };

    // Shared by the scroll-triggered entry check and the reopen button —
    // shows the sticky bar in place, replaying the slide-in animation,
    // without requiring any further scrolling.
    const enterSticky = () => {
      if (isSticky || isLeaving) return;
      originalWrapperHeight = $gallery.getBoundingClientRect().height;
      watchWrapperSize();
      watchEmblaAlignment();
      // watchEmblaAlignment() only starts observing from this point on —
      // it can't retroactively catch a misalignment that already happened
      // while the customer was customizing the form, before ever scrolling
      // into sticky. Correcting once, synchronously, right here closes that
      // gap: whatever the last real mutation left the container at gets
      // checked immediately instead of only on the next future one.
      fixEmblaMockupAlignment();

      // The keyframe animation (customall-sticky-slide-in-down) plays
      // whenever .customall-gallery--sticky starts matching, so a plain
      // class add is enough — unlike a plain `transition`, it doesn't need
      // to be staged across two frames to avoid being batched into the
      // final state.
      // Measure while the carousel is still in normal flow. Once the sticky
      // class makes .customall-product-media fixed, Customily's percentage-
      // height chain can collapse to 0 before updateStickyHeight() gets a
      // usable measurement.
      updateStickyHeight();
      document.body.classList.add('customall-gallery--sticky');
      // Applied synchronously, not deferred to the next frame: the instant
      // .customall-gallery--sticky matches, .customall-product-media
      // becomes position:fixed and stops contributing to $gallery's layout
      // height, collapsing it — applyOverlayLayout() is what restores that
      // height so the page doesn't jump. Deferring that fix by even one
      // frame left a brief window with $gallery collapsed; scrolled near
      // the bottom of the page, the browser would clamp the now-too-large
      // scroll position down to fit the shorter page, firing a real
      // 'scroll' event that onScroll picked up mid-collapse — reading it as
      // "scrolled back up past the gallery" and immediately closing what
      // had just opened (most visible right after using the reopen button,
      // since that's the scenario closest to the bottom of the page).
      applyOverlayLayout();
      isSticky = true;
      // No window resize dispatch here (unlike the teeinblue version this
      // was ported from) — onGalleryStickyChange() below already reacts to
      // .customall-gallery--sticky via its own MutationObserver on body's
      // class, so nothing here needs the extra nudge. A synthetic resize
      // event is also a real signal to any OTHER script on the page that
      // watches window resize to reflow/redraw — including, very plausibly,
      // Customily's own canvas-based mockup renderer — for no benefit to
      // us, forcing potentially expensive work (this mockup's canvas is
      // often 1000px+ square) at the exact moment we want the transition
      // to feel instant.

      // A second, delayed correction on top of the immediate one above —
      // seen in practice landing on scroll-out-then-back-in: Embla settles
      // into a fresh (wrong) position sometime shortly AFTER this function
      // returns, most likely reacting to the exit resize dispatch (see
      // startLeaving()) or its own resize handling of the real layout
      // change from normal flow to position:fixed. Whatever the trigger,
      // it happens too late for the synchronous call above and, since it
      // occurs while isSticky is already true, should in theory already be
      // caught by watchEmblaAlignment()'s own observer — in practice it
      // wasn't reliably, so this re-checks directly instead of trusting
      // that path alone.
      setTimeout(fixEmblaMockupAlignment, 300);
    };

    // Plays the slide-out-up animation before actually tearing down the
    // sticky layout, instead of vanishing instantly. Used both when scrolling
    // back out of the sticky range and when the close (X) button is clicked.
    // `manual` marks the latter — only then does a small reopen button show
    // up afterward, so scrolling back out on its own stays button-free.
    const startLeaving = (manual = false) => {
      if (!isSticky || isLeaving) return;
      isLeaving = true;
      if (manual) manuallyClosed = true;
      document.body.classList.add('customall-gallery--sticky--leaving');
      const galleryContent = document.querySelector(
        `${galleryWrapperSelector} .customall-product-media`
      );
      const finishLeaving = () => {
        document.body.classList.remove('customall-gallery--sticky', 'customall-gallery--sticky--leaving');
        clearOverlayLayout();
        isSticky = false;
        isLeaving = false;
        // Unlike entry (see enterSticky()), a resize dispatch here on the
        // way OUT is kept: removing it too left the real gallery blank
        // after leaving sticky — its own carousel evidently needs this
        // nudge to reflow back into normal (non-fixed, non-scaled) layout
        // correctly. Entry's problem was Customily redrawing an expensive
        // canvas at the exact moment we want the transition to feel
        // instant; that concern doesn't apply on the way out, where
        // nothing about the mockup content itself is changing.
        window.dispatchEvent(new Event('resize'));
        if (manual) showReopenButton();
      };
      if (galleryContent) {
        galleryContent.addEventListener('animationend', finishLeaving, { once: true });
      } else {
        finishLeaving();
      }
    };

    const onScroll = () => {
      const currentY = window.scrollY || window.pageYOffset || 0;

      if (
        lastCheckScrollY !== null &&
        Math.abs(currentY - lastCheckScrollY) < SAFETY_SCROLLING_RANGE
      ) {
        return;
      }
      lastCheckScrollY = currentY;

      const $productImagesWrapper = document.querySelector(
        `${galleryWrapperSelector} .product-images-wrapper`
      );
      if (!$productImagesWrapper) return;

      if (!hasCloseButton) {
        const closeButton = document.createElement('div');
        closeButton.className = 'customall-sticky-close-button';
        closeButton.addEventListener('click', e => {
          e.preventDefault();
          startLeaving(true);
        });
        document.body.appendChild(closeButton);
        hasCloseButton = true;
      }

      // Use the main carousel's viewport (the actual image) rather than the
      // whole wrapper (which also includes the thumbnail strip below it) —
      // otherwise the trigger waits for the thumbnails to scroll away too,
      // which lags behind the moment the image itself is actually gone from
      // view. Only meaningful while NOT sticky: once
      // .customall-gallery--sticky is active, the viewport lives inside the
      // position:fixed overlay, so its rect stops tracking scroll and just
      // reports the fixed on-screen spot (always a positive bottom) —
      // useless for detecting "scrolled back up".
      const $stage = document.querySelector(
        `${galleryWrapperSelector} .embla.main-carousel .embla__viewport`
      );
      const galleryTop = $gallery.getBoundingClientRect().top;

      let stageBottom;
      if (!isSticky) {
        stageBottom = ($stage || $gallery).getBoundingClientRect().bottom;
        stageOffsetFromGalleryTop = stageBottom - galleryTop;
      } else {
        // $gallery itself is never made position:fixed (only its child is),
        // so its top keeps tracking scroll correctly even while sticky.
        // Re-derive where the stage's bottom would be from that, using the
        // offset captured the last time it was actually measurable — this
        // stays consistent with the entry check above instead of drifting
        // to whatever the placeholder's reserved height happens to be,
        // which previously caused an immediate show-then-hide flicker right
        // after entering.
        stageBottom =
          galleryTop + (stageOffsetFromGalleryTop != null ? stageOffsetFromGalleryTop : 0);
      }

      const tForm = document.querySelector('#personalized-form');
      if (!tForm) return;

      const tFormBottom = tForm.getBoundingClientRect().bottom;

      // The gap that matters is between the form's bottom and the sticky
      // bar's OWN bottom edge (where it visually ends on screen), not the
      // viewport top (y=0) — the bar covers that whole top region anyway,
      // so the form disappearing "under" y=0 means nothing to the viewer.
      const $stickyContent = document.querySelector(
        `${galleryWrapperSelector} .customall-product-media`
      );
      const stickyBarBottom = isSticky && $stickyContent
        ? $stickyContent.getBoundingClientRect().bottom
        : 0;

      // Same range the gallery itself would use to show/hide — while
      // manually closed, the reopen button tracks that exact range instead
      // of the gallery, so it comes and goes at the same scroll positions
      // the gallery would have. Entry and exit use different thresholds
      // (see the gallery's own checks below) on purpose: showing needs the
      // image freshly out of view, but hiding should wait until actually
      // near the bottom of the form, not just dip below the entry
      // threshold — otherwise the button would disappear long before the
      // gallery itself ever would.
      if (stageBottom < 0 && tFormBottom > stickyCondHeight && !isSticky && !isLeaving) {
        if (manuallyClosed) {
          showReopenButton();
        } else {
          enterSticky();
        }
      }

      if (manuallyClosed) {
        // isSticky is always false here (entering is blocked while
        // manuallyClosed), so there's no real .customall-product-media
        // bottom to compare against — reconstruct what it WOULD be: the bar
        // always sits at top:0, so its bottom is just its height, still
        // available from the last time it was actually shown.
        const stickyBarHeightPx = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--customall-sticky-gallery-height')
        ) || 0;
        if (stageBottom > 0 || tFormBottom < stickyBarHeightPx + HIDE_NEAR_FORM_BOTTOM_PX) {
          hideReopenButton();
        }
      }

      if (
        isSticky &&
        !isLeaving &&
        // Only hide once the form's bottom edge has (almost) scrolled up to
        // meet the sticky bar's own bottom edge — not the viewport top — or
        // when scrolling back up reveals the real gallery.
        (tFormBottom < stickyBarBottom + HIDE_NEAR_FORM_BOTTOM_PX || stageBottom > 0)
      ) {
        startLeaving();
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      if (isSticky) updateStickyHeight();
    });

    // Zoom in/out controls for the sticky gallery — mobile AND only while
    // the gallery is sticky (.customall-gallery--sticky on <body>). The
    // normal (non-sticky) mobile gallery is left completely alone.
    const ZOOM_STEP = 0.1;
    const ZOOM_DEFAULT = 1;
    const ZOOM_MIN = 1;
    const ZOOM_MAX = 3;
    let zoomScale = ZOOM_DEFAULT;
    let zoomActive = false;
    // Pan offset in .product-images-wrapper's own local pixel space — see
    // the translate3d comment on its transform rule for why no
    // ancestor-scale conversion is needed here.
    let panX = 0;
    let panY = 0;

    function isGallerySticky() {
      return document.body.classList.contains('customall-gallery--sticky') && window.innerWidth < 768;
    }

    // Keeps the pan offset from ever revealing empty space past the edge of
    // the zoomed wrapper — clamped to how far the enlarged box extends
    // beyond .customall-product-media's (fixed) viewport in each direction.
    // transform-origin is "top center", so the box only grows downward and
    // sideways from there: panY has no positive slack (top edge already
    // sits at the content's own top) while panX is symmetric.
    //
    // The vertical clamp is measured against the main carousel's own
    // height, not wrapper.offsetHeight — the wrapper also contains the
    // (un-hidden, just clipped — see the CSS comment on .embla__button)
    // thumbnail strip below it, and clamping against its combined height
    // would let panning down at high zoom drag the thumbnails up into
    // view through the fixed box.
    //
    // viewH and mainCarouselH can both be passed in pre-measured — during a
    // drag this is called on every touchmove, and re-querying elements plus
    // forcing a layout read via getBoundingClientRect()/offsetHeight on
    // every call is a big part of why continuous dragging can feel janky.
    // Neither changes mid-drag, so the drag handlers measure them once up
    // front instead.
    function clampPan(wrapper, viewH, mainCarouselH) {
      if (viewH == null) {
        const content = document.querySelector('.customall-product-media');
        if (!content) return;
        viewH = content.getBoundingClientRect().height;
      }
      if (mainCarouselH == null) {
        const mainCarousel = document.querySelector('.embla.main-carousel .embla__viewport');
        mainCarouselH = mainCarousel ? mainCarousel.offsetHeight : wrapper.offsetHeight;
      }
      const totalScale = SCALE * zoomScale;
      const viewW = window.innerWidth;
      const maxPanX = Math.max(0, (wrapper.offsetWidth * totalScale - viewW) / 2);
      const maxPanY = Math.max(0, mainCarouselH * totalScale - viewH);
      panX = Math.min(maxPanX, Math.max(-maxPanX, panX));
      panY = Math.min(0, Math.max(-maxPanY, panY));
    }

    // Lean version of the pan half of applyZoom(), for use on every
    // touchmove during a drag — skips re-writing the scale var and
    // touch-action (neither changes mid-drag) and takes the already-cached
    // wrapper element and heights instead of re-querying/re-measuring them
    // on every call.
    function applyPan(wrapper, viewH, mainCarouselH) {
      clampPan(wrapper, viewH, mainCarouselH);
      document.documentElement.style.setProperty('--customall-gallery-pan-x', `${panX}px`);
      document.documentElement.style.setProperty('--customall-gallery-pan-y', `${panY}px`);
    }

    // Combines the base shrink-to-fit scale with the current zoom level into
    // one number and hands it to .product-images-wrapper via the CSS var
    // its transform reads from — scaling the whole wrapper (image and
    // thumbnail strip together) rather than just the image alone.
    function applyZoom() {
      if (!zoomActive) return;
      const wrapper = document.querySelector('.product-images-wrapper');
      document.documentElement.style.setProperty(
        '--customall-gallery-total-scale',
        `${SCALE * zoomScale}`
      );
      if (wrapper) {
        clampPan(wrapper);
        document.documentElement.style.setProperty('--customall-gallery-pan-x', `${panX}px`);
        document.documentElement.style.setProperty('--customall-gallery-pan-y', `${panY}px`);
        // Only claim the drag gesture once actually zoomed in — at 1x the
        // page must keep scrolling normally through the gallery.
        wrapper.style.touchAction = zoomScale > ZOOM_MIN ? 'none' : 'pan-y';
      }

      const controls = document.querySelector('.customall-zoom-controls');
      if (!controls) return;
      controls.querySelector('.customall-zoom-in').disabled = zoomScale >= ZOOM_MAX;
      controls.querySelector('.customall-zoom-out').disabled = zoomScale <= ZOOM_MIN;
    }

    function resetZoom() {
      zoomScale = ZOOM_DEFAULT;
      panX = 0;
      panY = 0;
      applyZoom();
    }

    // Undo our override so .product-images-wrapper falls back to its plain
    // SCALE rule — the normal (non-sticky) mobile gallery never had this
    // var set anyway.
    function clearZoom() {
      document.documentElement.style.removeProperty('--customall-gallery-total-scale');
      document.documentElement.style.removeProperty('--customall-gallery-pan-x');
      document.documentElement.style.removeProperty('--customall-gallery-pan-y');
      const wrapper = document.querySelector('.product-images-wrapper');
      if (wrapper) wrapper.style.removeProperty('touch-action');
      panX = 0;
      panY = 0;
    }

    // Lets the user drag to pan around the gallery once it's zoomed in past
    // 1x — otherwise the parts clipped by .customall-product-media's
    // overflow:hidden would be permanently out of reach. Listens on
    // .product-images-wrapper itself in the CAPTURE phase (not bubble):
    // Embla's own carousel has its own swipe-to-change-slide gesture
    // wired up somewhere inside it, and a bubble-phase listener here would
    // run after that handler; capture runs top-down, before the event ever
    // reaches it.
    //
    // Touch Events (not Pointer Events) drive the actual pan tracking: this
    // feature only ever runs on mobile (see the h/w check gating the whole
    // script), and Pointer Events have a history of being unreliable or
    // outright unsupported on some mobile browsers (older iOS Safari in
    // particular) — a real device could block the page's own scroll via
    // touch-action just fine while never actually firing the pointer events
    // this logic depended on, making drag look like it does nothing at all.
    // Touch Events are the one API that's been consistently supported
    // everywhere touch input exists.
    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragStartPanX = 0;
    let dragStartPanY = 0;
    // Cached once per drag (touchstart), not re-queried/re-measured on every
    // touchmove — see clampPan()/applyPan() above for why that matters.
    let dragWrapperEl = null;
    let dragViewH = 0;
    let dragMainCarouselH = 0;
    // touchmove can fire far more often than the display repaints; applying
    // every single event synchronously did the (already trimmed-down) pan
    // update work that many extra times for no visible benefit and was a
    // real source of jank. Coalesce to at most once per frame instead —
    // only the latest finger position by the time the frame actually runs
    // matters.
    let dragRafPending = false;
    let dragLatestX = 0;
    let dragLatestY = 0;

    function onWrapperTouchStart(e) {
      if (!zoomActive || zoomScale <= ZOOM_MIN) return;
      const wrapper = document.querySelector('.product-images-wrapper');
      if (!wrapper || !wrapper.contains(e.target)) return;
      if (e.touches.length !== 1) return;
      const content = document.querySelector('.customall-product-media');
      if (!content) return;
      const mainCarousel = document.querySelector('.embla.main-carousel .embla__viewport');
      e.stopPropagation();
      isDragging = true;
      dragWrapperEl = wrapper;
      dragViewH = content.getBoundingClientRect().height;
      dragMainCarouselH = mainCarousel ? mainCarousel.offsetHeight : wrapper.offsetHeight;
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      dragStartPanX = panX;
      dragStartPanY = panY;
    }

    function onWrapperTouchMove(e) {
      if (!isDragging) return;
      const touch = e.touches[0];
      if (!touch) return;
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();
      dragLatestX = touch.clientX;
      dragLatestY = touch.clientY;
      if (dragRafPending) return;
      dragRafPending = true;
      requestAnimationFrame(() => {
        dragRafPending = false;
        if (!isDragging) return;
        panX = dragStartPanX + (dragLatestX - dragStartX);
        panY = dragStartPanY + (dragLatestY - dragStartY);
        applyPan(dragWrapperEl, dragViewH, dragMainCarouselH);
      });
    }

    function onWrapperTouchEnd(e) {
      if (!isDragging) return;
      e.stopPropagation();
      isDragging = false;
      dragWrapperEl = null;
    }

    // Purely defensive: stops pointerdown/move/up from bubbling too, in case
    // Embla's own gesture handling listens for Pointer Events rather than
    // (or in addition to) raw Touch Events — doesn't drive any panning
    // itself, Touch Events above already do that.
    function blockPointerDuringZoomDrag(e) {
      if (!zoomActive || zoomScale <= ZOOM_MIN) return;
      const wrapper = document.querySelector('.product-images-wrapper');
      if (!wrapper || !wrapper.contains(e.target)) return;
      e.stopPropagation();
    }

    let dragListenersAttached = false;
    function attachDragListeners() {
      if (dragListenersAttached) return;
      const wrapper = document.querySelector('.product-images-wrapper');
      if (!wrapper) return;
      dragListenersAttached = true;
      wrapper.addEventListener('touchstart', onWrapperTouchStart, { capture: true, passive: false });
      wrapper.addEventListener('touchmove', onWrapperTouchMove, { capture: true, passive: false });
      wrapper.addEventListener('touchend', onWrapperTouchEnd, { capture: true });
      wrapper.addEventListener('touchcancel', onWrapperTouchEnd, { capture: true });
      wrapper.addEventListener('pointerdown', blockPointerDuringZoomDrag, { capture: true });
      wrapper.addEventListener('pointermove', blockPointerDuringZoomDrag, { capture: true });
      wrapper.addEventListener('pointerup', blockPointerDuringZoomDrag, { capture: true });
      wrapper.addEventListener('pointercancel', blockPointerDuringZoomDrag, { capture: true });
    }

    function injectZoomControls() {
      attachDragListeners();
      // Appended to .customall-product-media (not .product-images-wrapper):
      // the wrapper carries the zoom's own transform:scale() — any child of
      // it gets shrunk/grown along with the image. .customall-product-media
      // is the outer (unscaled) flex bar, so the controls stay full size
      // and are free to sit in the margin beside the scaled content instead
      // of being boxed into it.
      const content = document.querySelector('.customall-product-media');
      if (!content || content.querySelector('.customall-zoom-controls')) return;

      const controls = document.createElement('div');
      controls.className = 'customall-zoom-controls';
      controls.innerHTML = `
        <button type="button" class="customall-zoom-in" aria-label="Zoom in">+</button>
        <button type="button" class="customall-zoom-out" aria-label="Zoom out">&minus;</button>
      `;
      content.appendChild(controls);

      controls.querySelector('.customall-zoom-in').addEventListener('click', e => {
        e.preventDefault();
        zoomScale = Math.min(ZOOM_MAX, +(zoomScale + ZOOM_STEP).toFixed(2));
        applyZoom();
      });
      controls.querySelector('.customall-zoom-out').addEventListener('click', e => {
        e.preventDefault();
        zoomScale = Math.max(ZOOM_MIN, +(zoomScale - ZOOM_STEP).toFixed(2));
        applyZoom();
      });
    }

    // Entering sticky: (re)inject the controls if needed, then apply zoom.
    function activateZoom() {
      // Always start fresh at the default scale/pan — don't carry over
      // whatever zoom level was left from a previous sticky session.
      zoomScale = ZOOM_DEFAULT;
      panX = 0;
      panY = 0;
      injectZoomControls();
      applyZoom();
    }

    function onGalleryStickyChange() {
      const sticky = isGallerySticky();
      if (sticky === zoomActive) return;
      zoomActive = sticky;
      if (sticky) {
        activateZoom();
      } else {
        clearZoom();
      }
    }

    new MutationObserver(onGalleryStickyChange).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
    window.addEventListener('resize', onGalleryStickyChange);
    onGalleryStickyChange();
  };

  const w = window.innerWidth;

  if (w < 768) {
    setTimeout(fixedLivePreview, 2000);
  }
});
